import { LoginTypeEnum, OTPEnum } from '@protos/user_management/ums.db_pb';
import {
  StudentLoginResponseType,
  UserInfo,
} from '@protos/user_management/ums.login.apis_pb';
import { createSlice } from '@reduxjs/toolkit';
// import {} from '@protos/common/'

interface IOtpInfo {
  verification_code: string;
  otp_type: OTPEnum;
}
interface InfoToast {
  label: string | React.ReactElement;
  variant: 'success' | 'error' | 'info';
  open: boolean;
}
export interface IAuthState {
  userInfo?: StudentLoginResponseType;
  contactPopupOpen: boolean;
  skipped_feature_screens: boolean;
  login_Type?: LoginTypeEnum;
  login_uid?: string;
  login_phone?: string;
  login_email?: string;
  multiple_profiles?: StudentLoginResponseType[];
  otp_info?: IOtpInfo;
  verify_path: '/verify-phone' | '/verify-email' | '';
  toast_info: InfoToast;
  password_verfication?: string;
  user_validation_info?: UserInfo;
  is_mcb_user?: boolean;
  is_logged_in_offline?: boolean;
  is_mobile_number_changed?: boolean;
  is_email_id_changed?: boolean;
  ssoRedirectionUrl?: string;
  is_home_banner_shown?: boolean;
  isLoggingOut?: boolean;
  showNameEditPopup?: boolean;
  isNameEditPopupShown?: boolean;
  session_mode?: 'learn' | 'assess';
  is_sso_user?: boolean;
  sso_subject_id?: number;
  sso_subject_ids?: number[];
}

const initialState: IAuthState = {
  userInfo: undefined,
  contactPopupOpen: false,
  skipped_feature_screens: false,
  verify_path: '',
  toast_info: { label: '', variant: 'success', open: false },
  is_mcb_user: false,
  is_logged_in_offline: false,
  is_mobile_number_changed: false,
  is_email_id_changed: false,
  is_home_banner_shown: false,
  isLoggingOut: false,
  showNameEditPopup: false,
  isNameEditPopupShown: false,
  session_mode: undefined,
  is_sso_user: undefined,
  sso_subject_id: undefined,
  sso_subject_ids: undefined,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setContactPopupOpen: (state, action) => {
      state.contactPopupOpen = action.payload;
    },
    setSkippedFeatureScreens: (state, action) => {
      state.skipped_feature_screens = action.payload;
    },

    setLoginUID: (state, action) => {
      if (state.login_phone) {
        state.login_phone = undefined;
      }
      if (state.login_email) {
        state.login_email = undefined;
      }
      state.login_uid = action.payload;
      state.login_Type = LoginTypeEnum.LOGIN_TYPE_USERNAME;
    },
    setLoginPhone: (state, action) => {
      if (state.login_uid) {
        state.login_uid = undefined;
      }
      if (state.login_email) {
        state.login_email = undefined;
      }
      state.login_phone = action.payload;
      state.login_Type = LoginTypeEnum.LOGIN_TYPE_PHONE_NUMBER;
    },
    setLoginEmail: (state, action) => {
      if (state.login_phone) {
        state.login_phone = undefined;
      }
      if (state.login_uid) {
        state.login_uid = undefined;
      }
      state.login_email = action.payload;
      state.login_Type = LoginTypeEnum.LOGIN_TYPE_EMAIL;
    },
    setMultipleProfiles: (state, action) => {
      state.multiple_profiles = action.payload;
    },
    setOtpInfo: (state, action) => {
      state.otp_info = action.payload;
    },
    setToastInfo: (state, action) => {
      state.toast_info = action.payload;
    },
    toggleToastOpen: (state, action) => {
      state.toast_info.open = action.payload;
    },
    setUserValidationInfo: (state, action) => {
      state.user_validation_info = action.payload;
    },
    setPasswordVerificationToken: (state, action) => {
      state.password_verfication = action.payload;
    },
    setVerifyPath: (state, action) => {
      state.verify_path = action.payload;
    },
    setIsMCBUser: (state, action) => {
      state.is_mcb_user = action.payload;
    },
    setIsLoggedInOffline: (state, action) => {
      state.is_logged_in_offline = action.payload;
    },
    setSsoRedirectionUrl: (state, action) => {
      state.ssoRedirectionUrl = action.payload;
    },
    setMobilenumberChanged: (state, action) => {
      state.is_mobile_number_changed = action.payload;
    },
    setEmailIdChanged: (state, action) => {
      state.is_email_id_changed = action.payload;
    },
    setIsHomeBannerShown: (state, action) => {
      state.is_home_banner_shown = action.payload;
    },
    setIsLoggingOut: (state, action: { payload: boolean }) => {
      state.isLoggingOut = action.payload;
    },
    setShowNameEditPopup: (state, action: { payload: boolean }) => {
      state.showNameEditPopup = action.payload;
    },
    setIsNameEditPopupShown: (state, action: { payload: boolean }) => {
      state.isNameEditPopupShown = action.payload;
    },
    setSessionMode: (
      state,
      action: { payload: 'learn' | 'assess' | undefined }
    ) => {
      state.session_mode = action.payload;
    },
    setIsSsoUser: (state, action: { payload: boolean }) => {
      state.is_sso_user = action.payload;
    },
    setSsoSubjectIds: (state, action: { payload: number[] }) => {
      state.sso_subject_ids = action.payload;
    },
    resetAuthState: (state) => {
      return initialState;
    },
  },
});

export const {
  setUserInfo,
  setContactPopupOpen,
  setSkippedFeatureScreens,
  setToastInfo,
  toggleToastOpen,
  setLoginUID,
  setLoginPhone,
  setLoginEmail,
  setMultipleProfiles,
  setOtpInfo,
  resetAuthState,
  setPasswordVerificationToken,
  setUserValidationInfo,
  setVerifyPath,
  setIsMCBUser,
  setIsLoggedInOffline,
  setMobilenumberChanged,
  setEmailIdChanged,
  setSsoRedirectionUrl,
  setIsHomeBannerShown,
  setIsLoggingOut,
  setShowNameEditPopup,
  setIsNameEditPopupShown,
  setSessionMode,
  setIsSsoUser,
  setSsoSubjectIds,
} = authSlice.actions;
export default authSlice.reducer;
